import React from 'react';


const Footer = () => {
    return (
        <footer className="row bg-light py-4 mt-auto">
        <div className="col">
            Copyright 2026 <strong>JAIS AI</strong>
        </div>
    </footer>
    );
};

export default Footer;